export default __webpack_public_path__ + "static/blob8-ec2cb4f9ba4fc16cb5a2a7d92c7bf360.svg";